import { SET_PART_REFERENCES, ADD_PART } from "../actions/types";

export const addToPartReference = part => dispatch => {
  dispatch({
    type: ADD_PART,
    payload: part,
  });
};
